import React from 'react';
import { CatalogGroupListItem } from './CatalogGroupListItem';
import { CatalogGroup } from '@/types';
import { NoResultsCard } from '@/components/Cards';
import { useCanScroll } from '@/utils/hooks';

interface CatalogGroupListProps {
    groups: CatalogGroup[];
    onEditClick?(group: CatalogGroup): void;
    onDelete?(group: CatalogGroup): void;
    defaultExpandedId?: number;
}

export const CatalogGroupList: React.FC<CatalogGroupListProps> = ({ groups, onEditClick, onDelete, defaultExpandedId }) => {
    const canScroll = useCanScroll(defaultExpandedId);

    return (
        <>
            {groups.map((g) => (
                <CatalogGroupListItem
                    defaultExpand={canScroll && defaultExpandedId === g.id}
                    key={g.id}
                    group={g}
                    onEditClick={onEditClick}
                    onDelete={onDelete}
                />
            ))}

            {groups.length === 0 && <NoResultsCard />}
        </>
    );
};